module.exports = {
	"pagination": {
		"ListHealthChecks": {
			"input_token": "Marker",
			"output_token": "NextMarker",
			"more_results": "IsTruncated",
			"limit_key": "MaxItems",
			"result_key": "HealthChecks"
		},
		"ListHostedZones": {
			"input_token": "Marker",
			"output_token": "NextMarker",
			"more_results": "IsTruncated",
			"limit_key": "MaxItems",
			"result_key": "HostedZones"
		},
		"ListResourceRecordSets": {
			"more_results": "IsTruncated",
			"limit_key": "MaxItems",
			"result_key": "ResourceRecordSets",
			"input_token": [
				"StartRecordName",
				"StartRecordType",
				"StartRecordIdentifier"
			],
			"output_token": [
				"NextRecordName",
				"NextRecordType",
				"NextRecordIdentifier"
			]
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/route53-2013-04-01.paginators.json
// module id = 690
// module chunks = 0 1 2 3 4 6 7 8